// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimAdjudicationMedicalInsurance {
    static getAttributeTypeMap() {
        return ClaimAdjudicationMedicalInsurance.attributeTypeMap;
    }
}
ClaimAdjudicationMedicalInsurance.discriminator = undefined;
ClaimAdjudicationMedicalInsurance.attributeTypeMap = [
    {
        "name": "primaryInsuranceCarrier",
        "baseName": "primaryInsuranceCarrier",
        "type": "string"
    },
    {
        "name": "groupPlanName",
        "baseName": "groupPlanName",
        "type": "string"
    },
    {
        "name": "groupNumber",
        "baseName": "groupNumber",
        "type": "string"
    },
    {
        "name": "policyNumber",
        "baseName": "policyNumber",
        "type": "string"
    },
    {
        "name": "effectiveDate",
        "baseName": "effectiveDate",
        "type": "string"
    }
];
//# sourceMappingURL=claimAdjudicationMedicalInsurance.js.map